import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ViewModeToggle = ({ viewMode, onViewModeChange }) => (
  <div className="flex items-center bg-muted rounded-md p-1">
    <Button
      variant={viewMode === 'grid' ? 'secondary' : 'ghost'}
      size="icon"
      onClick={() => onViewModeChange('grid')}
      aria-label="Grid View"
    >
      <Icon name="Grid3X3" />
    </Button>
    <Button
      variant={viewMode === 'map' ? 'secondary' : 'ghost'}
      size="icon"
      onClick={() => onViewModeChange('map')}
      aria-label="Map View"
    >
      <Icon name="Map" />
    </Button>
    <Button
      variant={viewMode === 'list' ? 'secondary' : 'ghost'}
      size="icon"
      onClick={() => onViewModeChange('list')}
      aria-label="List View"
    >
      <Icon name="List" />
    </Button>
  </div>
);

const ControlsBar = ({
  resultsCount,
  viewMode,
  onViewModeChange,
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" iconName="Heart" className="text-muted-foreground">
          Save Search
        </Button>
        <div className="text-sm text-muted-foreground pl-2 border-l border-border">
          {resultsCount > 0 ? (
            <span>
              <span className="font-medium text-foreground">{resultsCount.toLocaleString()}</span> results
            </span>
          ) : (
            <span>No results</span>
          )}
        </div>
      </div>

      <div className="flex items-center justify-end">
        <ViewModeToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
      </div>
    </div>
  );
};

export default ControlsBar;